<template>
    <v-sheet class="py-3" width="100%">
        <v-row class="py-3 greyE02" no-gutters>
            <v-spacer></v-spacer>
            <v-col class="py-1 pr-2" cols="4">
                <v-btn
                    class="px-0" width="100%" height="40" color="grey008"
                    @click="$store.commit('setPickLvnRmMdl', true)"
                    dense outlined>
                    <div class="d-flex align-center">
                        <span class="mr-3" style="font-size: 16px;">{{ $store.getters.getPickLvnRmNm }}</span>
                        <v-spacer></v-spacer>
                        <v-icon class="pt-1">mdi-menu-down</v-icon>
                    </div>
                </v-btn>
            </v-col>
            <v-col class="py-1 pl-2" cols="4">
                <v-text-field
                    v-model="nmSrch"
                    label="이름검색" @input="lstMltplSrch"
                    dense outlined hide-details>
                </v-text-field>
            </v-col>
            <v-spacer></v-spacer>
        </v-row>
        <v-row class="align-center mt-5 mb-3" no-gutters>
            <v-icon class="font-weight-medium mr-1" size="26">mdi-chevron-right</v-icon>
            <span class="grey006--text font-weight-medium">수급자 목록</span>
            <v-spacer></v-spacer>
            <span class="grey006--text fontDotNine mr-3">전체: {{ bnfcrList.length }}명</span>
        </v-row>
        <v-divider class="white mt-4"></v-divider>
        <div
            v-if="bnfcrList.length > 0"
            class="d-inline-block overflow-y-auto"
            :style="{ 'width': '100%', 'height': ($vuetify.breakpoint.height - 212) + 'px' }">
            <v-divider class="mx-2"></v-divider>
            <v-row
                v-for="(lst, i) in bnfcrList" :key="i"
                class="pa-0 mx-2 tableBB"
                no-gutters>
                <v-col class="overflow-text-hidden pa-3" cols="10">
                    <v-row class="pa-0" no-gutters>
                        <span class="fontOne font-weight-medium">{{ lst.name }} &#40;&nbsp;</span>
                        <span v-if="lst.gndr == 'M'" class="fontOne font-weight-medium">남</span>
                        <span v-else-if="lst.gndr == 'F'" class="fontOne font-weight-medium">여</span>
                        <span class="fontOne font-weight-medium">&nbsp;/&nbsp;{{ lst.age }}세 &#41;</span>
                        <span v-if="lst.lvnRmNm != ''" class="fontOne font-weight-medium">&nbsp;- {{ lst.lvnRmNm }}</span>
                    </v-row>
                    <v-divider class="white" style="padding: 1px 0;"></v-divider>
                    <v-row class="pa-0" no-gutters>
                        <span class="fontDotEight grey006--text mr-2">{{ lst.entStcdNm }},</span>
                        <span class="fontDotEight grey006--text mr-2">{{ lst.acknwRtngNm }},</span>
                        <span class="fontDotEight grey006--text">{{ lst.copayRateNm }}</span>
                    </v-row>
                </v-col>
                <v-col class="" style="padding-top: 15px; padding-left: 6px;" cols="2">
                    <v-btn color="grey006" @click="goPage(lst)" icon large>
                        <v-icon style="margin-left: 1px; margin-top: 1px;">mdi-chevron-right</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row class="pa-0 mx-2 tableBB" no-gutters>
                <v-col class="txtAlgnMid px-2 py-2" cols="12">
                    <span class="fontDotEight">조회된 목록이 없습니다.</span>
                </v-col>
            </v-row>
        </div>
    </v-sheet>
</template>

<script>
import { http } from '@/assets/js/baseAxios';

export default {
    name: 'BnfcrMgmt',

    components: {

    },

    props: {

    },

    created: function(){

    },

    mounted: function(){
        this.$nextTick(function () {
            this.$parent.$parent.appBarTtl = '수급자 관리'
            //this.sltHypDt = this.$store.getters.getPrsntDt('yyyy-mm-dd')
            this.getMobBnfcrList('', null, '')
        })
    },

    computed: {
        getSltLvnRmNm: function(){
            return this.$store.getters.getPickLvnRmNm
        },
    },

    watch:{
        getSltLvnRmNm: function(){
            this.lstMltplSrch()
        },
    },
        
    methods: {
        // 수급자 목록 조회
        getMobBnfcrList: function (bnfrcNm, stcd, lvnNm){
            this.$store.commit('setCmmLdrCricle', true)
            this.bnfcrList.splice(0)

            http.post('empApp/selModBnfcrList', { srchWd1: bnfrcNm, entStcd: stcd, srchWd2: lvnNm })
                .then((response) => ( this.bnfcrListRst(response.data) ))
                .catch((error) => console.log('axios error /empApp/selModBnfcrList : ' + error))
        },

        bnfcrListRst: function (res){
            if(res.statusCode == '200'){
                this.isBtn = res.result.isViw
                res.result.list.forEach(itm => {
                    if(this.vCd63.length == 0)
                        this.vCd63 = res.result.codes.vCd63
                    if(this.vCd65.length == 0)
                        this.vCd65 = res.result.codes.vCd65

                    let chc = res.result.codes.vCd65.findIndex( v => v.valcd == itm.entStcd )
                    if(chc > -1)
                        itm.entStcdNm = res.result.codes.vCd65[chc].valcdnm
                    else
                        itm.entStcdNm = ''

                    let idx = res.result.codes.vCd63.findIndex( v => v.valcd == itm.copayRate )
                    if(idx > -1)
                        itm.copayRateNm = res.result.codes.vCd63[idx].valcdnm
                    else
                        itm.copayRateNm = ''

                    if(itm.lvnRmNm == null)
                        itm.lvnRmNm = ''

                    if(itm.acknwRtng == '99')
                        itm.acknwRtngNm = '등급외'
                    else
                        itm.acknwRtngNm = itm.acknwRtng + '등급'

                });

                this.bnfcrList =  res.result.list
            }
            else{
                this.$store.commit('setCmmAlertMdl', true)
                this.$store.commit('setCmmAlertCntn', { clr: 'warning', cntn: res.message })
            }

            this.$store.commit('setCmmLdrCricle', false)
        },

        // 리스트 검색
        lstMltplSrch: function (){
            let chc = this.$store.getters.getPickLvnRmNm
            if(chc == '전체')
                chc = ''

            this.getMobBnfcrList(this.nmSrch, null, chc)
        },

        // 상세 페이지 이동
        goPage: function (obj){
            if(this.isBtn)
                this.$router.push(
                    {
                        name: 'BnfcrDtl',
                        params: { bnMmbrPk: obj.bnMmbrPk, bnfcrPk: obj.bnfcrPk, vCd63: this.vCd63, vCd65: this.vCd65 }
                    }
                )
            else{
                let obj = {}
                obj.clr = 'info'
                obj.cntn = '권한이 없습니다.'
                this.$store.commit('setCmmAlertMdl', true)
                this.$store.commit('setCmmAlertCntn', obj)
            }
        },
    },

    data: () => ({
        isBtn: false,
        nmSrch: '',
        bnfcrList: [],
        vCd63: [],
        vCd65: [],
    }),
};
</script>